import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const SuscriptionSlice =  createSlice({
    name:"SuscriptionId",
    initialState:{
        id:0
    },
    reducers:{
        SetId(state, action: PayloadAction<number>){
            state.id = action.payload
        }
    }
});

export const { SetId } = SuscriptionSlice.actions
export default SuscriptionSlice.reducer